<div class="wrapper">
  <div
    class="value plan"
    [matTooltip]="String(planFactValue.plan)"
    [matTooltipShowDelay]="1500"
  >
    <span>
      @if (isBudgetColumn) {
        {{ formatBudgetValue(planFactValue.plan) }}
      } @else {
        {{ formatNumberForDisplay(planFactValue.plan) }}
      }
    </span>
  </div>
  <div
    class="value fact"
    [matTooltip]="String(planFactValue.fact)"
    [matTooltipShowDelay]="1500"
  >
    <span
      [class]="{
        'less-than-plan': isFactLessThanPlan(),
        'greater-than-plan': !isFactLessThanPlan(),
      }"
    >
      @if (isBudgetColumn) {
        {{ formatBudgetValue(planFactValue.fact) }}
      } @else {
        {{ formatNumberForDisplay(planFactValue.fact) }}
      }
    </span>
  </div>
</div>
